import { OrionPluginOptions } from '@vuemodel/orion-pinia-orm'
import DeviceAuditHistory from 'modules/DeviceAuditHistory/DeviceAuditHistory'
import { LevelNode } from 'modules/LevelNode/LevelNode'
import { Org } from 'modules/Org/Org'
import { Tenant } from 'modules/Tenant/Tenant'
import { Transaction } from 'modules/Transaction/Transaction'
import makeSqliteStorer from 'services/storage/local/makeSqliteStorer'
import { getApiBaseUrl } from 'utils/getApiBaseUrl'
import { cleanScopeHeaders } from 'utils/scopeHeaders'
import { readFuelloxAuthToken } from 'src/auth/readFuelloxAuthToken'

const orionPiniaOrm: OrionPluginOptions = {
  providers: {
    default: {
      get apiEndpoint () {
        return getApiBaseUrl() + '/api'
      },
      async getRequestHeaders (options?: {
        withoutTenant?: boolean | undefined,
        withoutOrg?: boolean | undefined,
        withoutToken?: boolean | undefined,
      }) {
        const promises: Promise<void>[] = []

        const headers: Record<string, string> = {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }

        if (!options?.withoutToken) {
          promises.push(
            readFuelloxAuthToken(() => makeSqliteStorer('fuellox', 'fuelloxToken').get())
              .then(val => {
                headers.Authorization = `Bearer ${val}`
              }))
        }

        if (!options?.withoutTenant) {
          promises.push(
            makeSqliteStorer('fuellox', 'tenantId')
              .get()
              .then(val => {
                headers['tenant-id'] = val ?? ''
              }))
        }

        if (!options?.withoutOrg) {
          promises.push(
            makeSqliteStorer('fuellox', 'orgId')
              .get()
              .then(val => {
                headers['org-id'] = val ?? ''
              }))
        }

        await Promise.all(promises)

        return cleanScopeHeaders(headers)
      },
    },
  },
  queueables: [
    Transaction,
    LevelNode,
    DeviceAuditHistory,
  ],
}

export default orionPiniaOrm
